import { Action, createReducer, on } from '@ngrx/store';
import * as WishlistActions from './wishlist.actions';
import { ICatalog } from '../../catalogs/models/catalogs.models';

export interface WishlistState {
  allWishlist: ICatalog[];
}

export const initialWishlistState: WishlistState = {
  allWishlist: [],
};

const featureReducer = createReducer(
  initialWishlistState,
  on(WishlistActions.FetchAllWishlistSuccess, (state, action) => ({
    ...state,
    allWishlist: action.wishlist.data,
  }))
);

export function wishlistReducer(state: WishlistState | undefined, action: Action) {
  return featureReducer(state, action);
}
